"use client";
import React, { useEffect } from "react";
import { motion, useInView } from "framer-motion";
import Tabs from "@/components/home/Tabs";
import LoanCalculator from "@/components/ui/LoanCalculator";
import Swal from "sweetalert2";
import { useRouter } from "next/navigation";
function page() {

  const router = useRouter();

  // Swal.fire({
  //   title: 'Notice',
  //   text: 'We only supply loans in Jan',
  //   icon: 'info',
  //   confirmButtonText: 'OK'
  // })

  useEffect(() => {
    router.push("/")
  
  }, [])
  

  return (
    <div className="md:container">
      {/* Loan Calculator Section */}
      <div className=" mt-6 mb-16">
        <LoanCalculator />
      </div>
      
      <div className="flex flex-col md:flex-row md:mt-16 mt-6 container">
        <motion.div
          initial={{ opacity: 0, translateX: -50 }}
          whileInView={{ opacity: 100, translateX: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="w-full md:w-1/2 flex flex-col justify-center"
        >
          <h1 className="leading-snug text-3xl md:text-6xl mb-4 md:mb-4">
            Access funds from the liquidity funding pool ecosystem.
          </h1>
          <motion.p
            initial={{ opacity: 0, translateY: 50 }}
            whileInView={{ opacity: 100, translateY: 0 }}
            transition={{ duration: 0.3, delay: 0.4 }}
            className="text-lg font-medium md:mt-5 max-w-2xl"
          >
            Borrow at fair rates and at fair terms.
          </motion.p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, translateX: 50 }}
          whileInView={{ opacity: 100, translateX: 0 }}
          transition={{ duration: 0.3, delay: 0.4 }}
          className="w-full md:w-1/2"
        >
          <img src="/assets/images/invest.svg" alt="" className="w-full" />
        </motion.div>
      </div>
      {/* <div className="flex flex-col md:flex-row md:mt-16 mt-6">
        <Tabs />
      </div> */}
    </div>
  );
}

export default page;
